import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { fetchProjects } from "../../api/project";
import Header from "../../components/layout/Header";

function AdminDashboard() {
  const [projects, setProjects] = useState([]);
  const [username, setUsername] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));

    if (!user || !user.username) {
      navigate("/login");
      return;
    }

    if (user.role !== "admin") {
      alert("관리자만 접근 가능한 페이지입니다.");
      navigate("/project/" + (user.project_ids?.[0] || ""));
      return;
    }

    setUsername(user.username);

    const loadProjects = async () => {
      try {
        const res = await fetchProjects();
        console.log("프로젝트 목록:", res.data);
        setProjects(res.data.projects);
      } catch (err) {
        console.error("프로젝트 목록 불러오기 실패:", err);
      }
    };

    loadProjects();
  }, [navigate]);

  const handleProjectClick = (projectId) => {
    // 선택한 프로젝트 ID를 로컬 스토리지에 저장
    localStorage.setItem("projectId", projectId);

    // 해당 프로젝트 페이지로 이동
    navigate(`/project/${projectId}`);
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div>
      <Header username={username} onLogout={handleLogout} />
      <div style={{ padding: "2rem" }}>
        <button
          onClick={() => navigate("/admin/users")}
          style={{ marginBottom: "1rem" }}
        >
          사용자 관리
        </button>
        <h3>전체 프로젝트 목록</h3>
        <ul>
          {Array.isArray(projects) &&
            projects.map((proj) => (
              <li key={proj.project_id || proj.id} style={{ margin: "1rem 0" }}>
                <button
                  onClick={() => handleProjectClick(proj.project_id || proj.id)}
                >
                  {proj.name || "이름없음"} ({proj.project_id || "ID없음"})
                </button>
                <button
                  href={`/admin/projects/${proj.project_id || proj.id}/edit`}
                >
                  <a
                    href={`/admin/projects/${proj.project_id || proj.id}/edit`}
                    style={{ marginLeft: "1rem" }}
                  >
                    수정
                  </a>
                </button>
              </li>
            ))}
        </ul>
      </div>
    </div>
  );
}

export default AdminDashboard;
